import { generateBaseQueryKeysList } from '@/queries/utils';

export const OPOBFF_CASE_KEYS = {
  main: 'opobffCases',
  activityLogs: 'activity-logs',
};

export const opobffCaseQueryKeys = {
  ...generateBaseQueryKeysList(OPOBFF_CASE_KEYS.main),
  getActivityLogs: (caseId?: string, ...args: unknown[]) =>
    [...opobffCaseQueryKeys.getItem(caseId), OPOBFF_CASE_KEYS.activityLogs, ...args] as const,
};
